















import { getUrlParam } from '@/utils/common';
import merchantApi from '@/api/merchant';
import { ServerResponse } from '@/interface/common';
import {Component, Vue } from 'vue-property-decorator';
@Component({
    name: 'ThirdPay'
  })
export default class ThirdPay extends Vue {
  orderId = '';
  tradeNo = '';
  callback = '';
  orderState = false;
  
  created() {
    document.title = '支付';
    this.orderId = getUrlParam('orderId');
    this.tradeNo = getUrlParam('tradeNo');
    this.callback = getUrlParam('callback');
    this.getActiveProduct();
  }

  // 获取商品数据
  getActiveProduct() {
    this.$http({
      url: `${merchantApi.getPaymentStatus.url}`,
      method: merchantApi.getPaymentStatus.method,
      params: {
        orderId: this.orderId,
        tradeNo: this.tradeNo
      }
    }).then((res: ServerResponse) => {
      const data = res.data;
      this.orderState=data
      console.log(data,1111);
      if (!data&&this.callback) {
        this.goToPay()
      }
    });
  }

  // 展示注册弹窗
  goToPay() {
    window.location.href = this.callback
  }
}
